<button
  class="chat-launcher"
  (click)="toggleChat()"
  [matTooltip]="(isOpen$ | async) ? 'Hide AI assistant' : 'Ask our AI assistant'"
  aria-label="Toggle AI chat"
>
  <span class="chat-launcher-icon" aria-hidden="true">
    <img class="chat-launcher-logo" src="assets/images/forlabplus-logo-light.png" alt="" />
  </span>
</button>
